// extracted by mini-css-extract-plugin
export default {"ChartContainer":"EnergyConsumptionChart_ChartContainer__DDrvp","BlurBackground":"EnergyConsumptionChart_BlurBackground__WpIMK","Title":"EnergyConsumptionChart_Title__sUQWt"};